import { render, staticRenderFns } from "./AgingaccountsrecReportDetail.vue?vue&type=template&id=80b71364"
import script from "./AgingaccountsrecReportDetail.vue?vue&type=script&lang=js"
export * from "./AgingaccountsrecReportDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports